import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, linkedSignal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { FormatValueModule } from '@blaze-shared/shared-feature';

import { MapMarker, MapMarkerStyles, MarkerStyle } from '../map.models';

@Component({
  selector: 'be-map-marker',
  imports: [AsyncPipe, MatIconModule, FormatValueModule],
  templateUrl: './map-marker.component.html',
  styleUrls: ['./map-marker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.--map-marker-fill-color]': 'activeStyle()?.fill?.color1',
    '[style.--map-marker-outline-color]': 'activeStyle()?.outline?.color1',
    '[style.--map-marker-label-color]': 'activeStyle()?.label?.color1',
    '[style.--map-marker-label-bg-color]': 'activeStyle()?.labelBackground?.color1',
  },
})
export class MapMarkerComponent {
  marker = input.required<MapMarker>();
  style = input(MarkerStyle.Pin);
  selected = input(false);
  cssStyles = input<Partial<MapMarkerStyles>>();

  protected readonly activeStyle = computed(() => {
    const cssStyles = this.cssStyles();
    return this.selected() ? cssStyles?.selected : cssStyles?.default;
  });

  protected readonly image = linkedSignal(() => {
    const marker = this.marker();
    return marker.fields.image && marker.item
      ? (marker.item[marker.fields.image.name] as string | undefined)
      : undefined;
  });

  MarkerStyle = MarkerStyle;

  onImageLoadingError(): void {
    this.image.set(undefined);
  }
}
